import {
  OutlineButton,
  SolidButton,
} from "@/components/StoreComponents/StoreButton";
import { ComponentProps } from "react";

export const CheckoutButton = (props: ComponentProps<typeof OutlineButton>) => {
  const { disabled, ...rest } = props;

  if (disabled) {
    return <OutlineButton disableMaxWidth {...rest} disabled />;
  }

  return <SolidButton disableMaxWidth {...rest} />;
};
